import { useSelector } from 'react-redux';
import core from '@gin-betting/core';
import { Arg2 } from 'tsargs';

import { State } from 'types';

const {
    utils: { checkEquality, checkEqualityAndMeasurePerf },
} = core;

const isEqual: Arg2<typeof useSelector> = (a, b) =>
    (__DEV__ ? checkEqualityAndMeasurePerf : checkEquality)(a, b, {
        maxDepth: 2,
    });

type TypedUseSelectorHook<TState> = <TSelected>(
    selector: (state: TState) => TSelected
) => TSelected;

const usePureSelector: TypedUseSelectorHook<State> = selector => {
    return useSelector(selector, isEqual);
};

export default usePureSelector;
